import { toast as sToast } from 'sonner';
import { ToastContent as ToastCmp } from "./ToastContent";
import { jsx as _jsx } from "react/jsx-runtime";
export var toast = {
  info: function info(title, opts) {
    return sToast.custom(function (id) {
      return /*#__PURE__*/_jsx(ToastCmp, {
        variant: "info",
        id: id,
        title: title,
        opts: opts
      });
    });
  },
  success: function success(title, opts) {
    return sToast.custom(function (id) {
      return /*#__PURE__*/_jsx(ToastCmp, {
        variant: "success",
        id: id,
        title: title,
        opts: opts
      });
    });
  },
  error: function error(title, opts) {
    return sToast.custom(function (id) {
      return /*#__PURE__*/_jsx(ToastCmp, {
        variant: "error",
        id: id,
        title: title,
        opts: opts
      });
    });
  },
  warning: function warning(title, opts) {
    return sToast.custom(function (id) {
      return /*#__PURE__*/_jsx(ToastCmp, {
        variant: "warning",
        id: id,
        title: title,
        opts: opts
      });
    });
  }
};